import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { MenuListUrlQueryParams, MenuListUrlSortField } from "./urls";
import MenuDetailsComponent from "./views/MenuDetails";
import MenuListComponent from "./views/MenuList";

const MenuList: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substr(1));
  const params = asSortParams(
    qs,
    MenuListUrlSortField
  ) as MenuListUrlQueryParams;

  return <MenuListComponent params={params} />;
};

const MenuDetails: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const qs = parseQs(location.search.substr(1));

  return <MenuDetailsComponent id={decodeURIComponent(id)} params={qs} />;
};

const NavigationRouter: React.FC = () => (
  <Routes>
    <Route element={<MenuList />} path={""} />
    <Route element={<MenuDetails />} path={":id"} />
  </Routes>
);

export default NavigationRouter;
